sew-icon {
    display: block;
    line-height: 0;

    svg {
        width: var(--svg-width, auto);
        height: var(--svg-height, auto);
        max-width: 100%;
    }
}

.invisible {
    display: none;
}
